module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-medical-b101db60.svg";